import { useState, useCallback } from 'react';

export default function useModal() {
  const [modal, setModal] = useState({ open: false });

  const confirm = useCallback(({ title, message, type = 'danger', icon = '⚠️', confirmText = 'Confirmar', cancelText = 'Cancelar' }) => {
    return new Promise(resolve => {
      setModal({
        open: true, title, message, type, icon, confirmText, cancelText,
        onConfirm: () => { setModal({ open: false }); resolve(true); },
        onCancel:  () => { setModal({ open: false }); resolve(false); },
      });
    });
  }, []);

  const alert = useCallback(({ title, message, type = 'info', icon = 'ℹ️', confirmText = 'Entendido' }) => {
    return new Promise(resolve => {
      setModal({
        open: true, title, message, type, icon, confirmText,
        onConfirm: () => { setModal({ open: false }); resolve(true); },
        onCancel: null,
      });
    });
  }, []);

  return { modal, confirm, alert };
}
